import React, { Component } from 'react';
import Search from '../Home/Search';
import { Link } from 'react-router-dom';

export class ContentDelivery extends Component {
    displayName = ContentDelivery.name

    render() {
        return (
            <div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-9">
                            <p className="TitlePadding Title">Content delivery</p>
                            <p className="TitlePadding BookBody">
                                Besides online access, Kluwer Law Online also offers a subscription-based FTP Delivery Service. Directly upon finalisation, i.e. 3 to 4 weeks prior to printing, files from the subscribed titles are delivered to a designated FTP folder for you to collect manually or automatically. You can use the files for inclusion on your own intranet system or online library.
                            </p>
                            <p className="TitlePadding BookBody">
                                The deliveries can consist of:
                                <br></br>

                                <ul className="ManualUl">
                                    <li>documents in PDF and bibliographical information in XML; or</li>
                                    <li>documents in PDF</li>
                                    <li>bibliographical information in XML (so that, in combination with IP or referring URL access, you can create links
                                        back to specific titles or documents on the Kluwer Law Online website).</li>
                                </ul>
                                <br></br>
                                We also offer free MARC records that can be downloaded <a href="http://52.201.236.94/prod.mrm/Home/Index" target="_blank">here.</a>
                                <br></br>
                                Please <Link to="/ContactSales" classname="LinkClass"> contact our sales department </Link> if you are interested in these services.
                            </p>
                        </div>
                    </div>

                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer Section/ContentDelivery.jsx